import { UserIdentification } from "./passwordReset-models";
import { SIMPLE_PAYMENTS_SERVICE_GW_PREFIX } from "../constants";
import { GetCustomerSignUpStatusResponse } from "./models";
import { createApiClientWithArgs } from "cy-fetch/lib/client";

export const signUpStatusUrl = `${SIMPLE_PAYMENTS_SERVICE_GW_PREFIX}/api/v1/simple_payments/customers/sign_up_status`;

export const getCustomerSignUpStatusClient = createApiClientWithArgs({
  zod: GetCustomerSignUpStatusResponse,
  argsFn: (args: UserIdentification) => {
    const searchParams = new URLSearchParams();
    // This should be moved to the api layer
    searchParams.set("mobile[isd]", args.mobile!.isd.replace(/\D/, ""));
    searchParams.set("mobile[number]", args.mobile!.number);

    return {
      url: `${signUpStatusUrl}?${searchParams.toString()}`,
      options: {
        method: "GET",
      },
    };
  },
});
